module.exports = __webpack_public_path__ + "img/HSL_logo.16b3ee49.png";